import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

interface CreateLedRingsInput {
  name: string;
  description: string;
}
export async function createLedRings(input: CreateLedRingsInput) {
  let data;
  data = await axios({
    url: API_URL,
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      query: `
        mutation createLedRings (
          $input:CreateLedRingsInput!
        ) {
            createLedRings(
                createLedRingsInput:$input
          )  
        }
      `,
      variables: {
        input,
      },
    },
  }).catch((e: any) => (data = e.response));
  return data;
}
export async function updateLedRing( input: CreateLedRingsInput, id: string) {
  let data: any;
  data = await axios({
    url: API_URL,
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      query: `
        mutation updateLedRing (
          $id: String!
          $input: CreateLedRingsInput!
        ) {
          updateLedRing(
            createLedRingsInput: $input
            id: $id
          ) 
        }
      `,
      variables: { 
        id, 
        input 
      },
    },
  }).catch((e: any) => (data = e.response));
  return data;
}

export interface GetLedRingsListType {
  id: string;
  name: string;
  mediaUrl: string;
  description: string;
}
export async function getLedRingList() {
    const data = await axios({
      url: API_URL,
      method: "post",
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        query: `
          query {
            getLedRingList {
                id
                name
                mediaUrl
                description
            }
          }
        `,
        variables: {},
      },
    });
    return data?.data?.data?.getLedRingList;
  }

  export async function getLedRings(
    where: {} = {},
    pagination: {} | undefined = undefined
  ) {
    const data = await axios({
      url: API_URL,
      method: "post",
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        query: `
                  query getLedRings(
                    $where: LedRingsResolver_GetLedRings_FilterInputType,
                    $paginate: PaginatorArgs
                    ) {
                      getLedRings (where:$where, paginate: $paginate) {
                        data {
                          id
                          name
                          mediaUrl
                          description
                          createdAt
                        }
                        totalPages
                        total
                        perPage
                        page
                      }
                  }
                  `,
        variables: { where, paginate: pagination },
      },
    });
    return data?.data?.data?.getLedRings;
  }